import React from 'react';

/**
 * Layout component that provides full-width layout with optional constrained content areas
 * This replaces the previous max-width centered containers to better utilize large screens
 */
const Layout = ({
  children,
  className = "",
  fullWidth = true,
  maxWidth = "7xl", // Options: sm, md, lg, xl, 2xl, 3xl, 4xl, 5xl, 6xl, 7xl, full
  padding = "px-4 sm:px-6 lg:px-8",
  py = "py-8"
}) => {
  // If fullWidth is true, the container spans full width
  // If fullWidth is false, it uses the maxWidth constraint
  const containerClasses = fullWidth
    ? `${padding} ${py} w-full ${className}`
    : `max-w-${maxWidth} mx-auto ${padding} ${py} ${className}`;

  return (
    <div className={containerClasses}>
      {children}
    </div>
  );
};

/**
 * Full-width section that spans the entire viewport width
 */
export const FullWidthSection = ({
  children,
  className = "",
  padding = "px-4 sm:px-6 lg:px-8",
  py = "py-8"
}) => {
  return (
    <section className={`w-full ${padding} ${py} ${className}`}>
      {children}
    </section>
  );
};

/**
 * Content wrapper that constrains content within a full-width section
 */
export const ContentWrapper = ({
  children,
  className = "",
  maxWidth = "7xl",
  centered = true,
  padding = "px-4 sm:px-6 lg:px-8"
}) => {
  const wrapperClasses = centered
    ? `max-w-${maxWidth} mx-auto ${padding} ${className}`
    : `max-w-${maxWidth} ${padding} ${className}`;

  return (
    <div className={wrapperClasses}>
      {children}
    </div>
  );
};

/**
 * Hybrid layout: full-width container with constrained content areas
 */
export const HybridLayout = ({
  children,
  className = "",
  outerPadding = "px-4 sm:px-6 lg:px-8",
  outerPy = "py-8",
  contentMaxWidth = "7xl"
}) => {
  return (
    <div className={`w-full ${outerPadding} ${outerPy} ${className}`}>
      <ContentWrapper maxWidth={contentMaxWidth}>
        {children}
      </ContentWrapper>
    </div>
  );
};

export default Layout;